define('@getgo/telemetry-client/jquery-buffered-queue',['jquery', '@getgo/buffered-queue'], function ($, BufferedQueue) { 'use strict';

    $ = 'default' in $ ? $['default'] : $;
    BufferedQueue = 'default' in BufferedQueue ? BufferedQueue['default'] : BufferedQueue;

    function on(window, evt, handler) {
        if (window.addEventListener) {
            window.addEventListener(evt, handler);
        } else if (window.attachEvent) {
            window.attachEvent('on' + evt, handler);
        }
    }

    function localStorageAvailable(window) {
        try {
            var storage = window.localStorage;
            var x = '__storage_test__';
            storage.setItem(x, x);
            var y = storage.getItem(x);
            storage.removeItem(x);
            return x == y;
        } catch (e) {
            return false;
        }
    }

    /**
     * Read all values from window.localStorage that have a key starting with the provided prefix
     *
     * @private
     *
     * @param {Window} window
     * @param {Array<string>} keys
     *
     * @returns {Array<object>}
     */
    function storageGet(window, keys) {
        return keys.map(function (key) {
            try {
                var data = JSON.parse(window.localStorage.getItem(key));

                if (Array.isArray(data)) {
                    return data;
                }
            } catch (e) {
                // ignore e
            }

            return [];
        }).reduce(function (a, b) {
            return a.concat(b);
        }, []);
    }

    /**
     * Find all keys from window.localStorage starting with the provided prefix
     *
     * @private
     *
     * @param {Window} window
     * @param {string} keyprefix
     *
     * @returns {Array<string>}
     */
    function storageKeys(window, keyprefix) {
        var i, key;

        var result = [];

        var storage = window.localStorage;

        for (i = 0; i < storage.length; i++) {
            key = storage.key(i);

            if (key.indexOf(keyprefix) === 0) {
                result.push(key);
            }
        }

        return result;
    }

    function storagePut(window, key, data) {
        try {
            window.localStorage.setItem(key, JSON.stringify(data));
        } catch (e) {
            // ignore
        }
    }

    function storageRemove(window, keys) {
        return keys.map(function (key) {
            try {
                return window.localStorage.removeItem(key);
            } catch (e) {
                return e;
            }
        });
    }

    /**
     * @private
     * @class JqueryBufferedQueueFactory
     *
     * @param {window} window
     */
    function JqueryBufferedQueueFactory(window) {

        /**
         * @memberOf JqueryBufferedQueueFactory#
         *
         * @param {string} url
         * @param {TelemetryOptions} options
         *
         * @returns {TelemetryTransport}
         */
        function createTransport(url, options) {

            var keyprefix = 'telemetry.' + url.replace(/^http(s?):\/\//, '');

            function connectToLocalStorage() {
                if (localStorageAvailable(window)) {
                    var storedKeys = storageKeys(window, keyprefix);

                    if (storedKeys.length) {
                        queue.add.apply(queue, storageGet(window, storedKeys));

                        storageRemove(window, storedKeys);
                    }

                    on(window, 'beforeunload', function () {
                        storagePut(window, keyprefix + options.id_run, queue.clear());
                    });
                }
            }

            function send(events) {
                var payload = {
                    events: events
                };

                // support old /report style payload if ev_schema_name is present
                if (options.ev_schema_name) {
                    payload = $.extend(payload, {
                        ev_schema_name: options.ev_schema_name,
                        ev_schema_ver: options.ev_schema_ver,
                        ev_source: options.ev_source,
                        id_run: options.id_run
                    });
                }

                return new Promise(function (resolve, reject) {
                    $.ajax({
                        type: 'PUT',
                        url: url,
                        contentType: 'application/json',
                        data: JSON.stringify(payload)
                    }).then(resolve, reject);
                });
            }

            var queue = new BufferedQueue({
                maxSize: parseInt(options.queuesize, 10) || undefined
            });

            queue.on('flush', function (queuecontent) {
                if (Array.isArray(queuecontent.data) && queuecontent.data.length) {
                    return send(queuecontent.data);
                }
            });

            if (localStorageAvailable(window)) {
                connectToLocalStorage();
            } else {
                on(window, 'beforeunload', queue.flush.bind(queue));
            }

            return {
                add: queue.add,
                flush: queue.flush
            };
        }

        this.createTransport = createTransport;
    }

    var jqueryBufferedQueue = new JqueryBufferedQueueFactory(typeof window != 'undefined' ? window : typeof global != 'undefined' ? global : self);

    return jqueryBufferedQueue;

});
